import PleaseWaitOverlay from 'components/PleaseWaitOverlay';
import { Mail, Phone } from 'lucide-react';

import useOpenBanking from './useOpenBanking';

const PaymentFormOpenBanking: React.FunctionComponent = function () {
  const { companyName, overlayLabel, showDetails, companyEmail, companyPhone } =
    useOpenBanking();
  return (
    <>
      <h2 className="text-16-24-b md:text-20-24-b mb-4 md:mb-8">
        Arrange payment with {companyName}
      </h2>
      <div className="flex flex-col p-4 md:p-6 border-2 shadow-lg border-neutral-300 bg-neutral-000 rounded-xl">
        <div className="m-auto my-4">
          <PleaseWaitOverlay
            icon="user"
            title={`If you would like to pay in full, please reach out to ${companyName}`}
            labelLine1={overlayLabel}
            footer={
              showDetails ? (
                <div className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-2 mt-6 text-14-22">
                  {companyEmail ? (
                    <>
                      <Mail className="text-purple-400 mb-auto" />
                      <a
                        className="mt-px text-blue-200 visited:text-violet-200 underline font-semibold"
                        href={`mailto:${companyEmail}`}
                      >
                        {companyEmail}
                      </a>
                    </>
                  ) : null}
                  {companyPhone ? (
                    <>
                      <Phone className="text-purple-400 mb-auto" />
                      <a
                        className="mt-px text-blue-200 visited:text-violet-200 underline font-semibold"
                        href={`tel:${companyPhone}`}
                      >
                        {companyPhone}
                      </a>
                    </>
                  ) : null}
                </div>
              ) : null
            }
          />
        </div>
      </div>
    </>
  );
};

export default PaymentFormOpenBanking;
